import React, { memo, forwardRef, useMemo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { generateSvgId } from 'src/lib/svg';

export const IconStack = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 12 12"
        data-fill-none
      >
        <g clipPath={`url(#${svgId})`}>
          <path
            d="M1 6V9C1 10.1044 3.23867 11 6 11C8.76133 11 11 10.1044 11 9V6"
            fill="white"
          />
          <path
            d="M1 6V9C1 10.1044 3.23867 11 6 11C8.76133 11 11 10.1044 11 9V6"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 3V5.99956C1 7.104 3.23867 7.99956 6 7.99956C8.76133 7.99956 11 7.10444 11 5.99956V3"
            fill="white"
          />
          <path
            d="M1 3V5.99956C1 7.104 3.23867 7.99956 6 7.99956C8.76133 7.99956 11 7.10444 11 5.99956V3"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1 3.00049C1 3.53092 1.52678 4.03963 2.46447 4.4147C3.40215 4.78977 4.67392 5.00049 6 5.00049C7.32608 5.00049 8.59785 4.78977 9.53553 4.4147C10.4732 4.03963 11 3.53092 11 3.00049C11 2.47006 10.4732 1.96135 9.53553 1.58627C8.59785 1.2112 7.32608 1.00049 6 1.00049C4.67392 1.00049 3.40215 1.2112 2.46447 1.58627C1.52678 1.96135 1 2.47006 1 3.00049Z"
            fill="white"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id={`url(#${svgId})`}>
            <rect
              width="12"
              height="12"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
